module.exports = [{"type":"flavor","text":"You buy a green-looking drink at random.","filters":[{"type":"resource","resource":"yen","minimum":200}],"effects":[{"type":"resource","resource":"yen","value":-200},{"type":"resource","resource":"stamina","value":20},{"type":"theme","theme":"theme-green"}]},{"type":"flavor","text":"You don't have enough money to buy this.","filters":[],"effects":[]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/green.json
// module id = 209
// module chunks = 0